module.exports = __webpack_public_path__ + "img/bonhomme-rouge.7637568b.png";